var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmptyTrainingcourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1657_2989)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1657_2989",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 0H0V120H120V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1657_2989)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M60 120C93.14 120 120 93.14 120 60C120 26.86 93.14 0 60 0C26.86 0 0 26.86 0 60C0 93.14 26.86 120 60 120Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.02 67.21C59.71 67.21 59.41 67.14 59.12 67L53.75 64.32C52.76 63.83 52.36 62.62 52.86 61.64C53.35 60.65 54.55 60.25 55.54 60.75L60.01 62.99L64.49 60.77C65.48 60.28 66.68 60.68 67.17 61.67C67.66 62.66 67.26 63.86 66.27 64.35L60.9 67.02C60.62 67.16 60.32 67.23 60.01 67.23L60.02 67.21Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.37 60.88C47.07 60.88 46.76 60.81 46.48 60.67L39.19 57.03C38.2 56.54 37.8 55.33 38.3 54.35C38.79 53.36 40 52.96 40.98 53.46L48.27 57.1C49.26 57.59 49.66 58.8 49.16 59.78C48.81 60.48 48.1 60.89 47.37 60.89V60.88Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.79 53.59C32.49 53.59 32.18 53.52 31.9 53.38L26.53 50.7C25.84 50.35 25.41 49.64 25.43 48.87C25.45 48.1 25.91 47.4 26.61 47.09L32.09 44.64C33.1 44.19 34.28 44.64 34.73 45.65C35.18 46.66 34.73 47.84 33.72 48.29L32.1 49.02L33.69 49.82C34.68 50.31 35.08 51.52 34.58 52.5C34.23 53.2 33.52 53.61 32.79 53.61V53.59Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.12 45.23C39.36 45.23 38.63 44.79 38.29 44.05C37.84 43.04 38.29 41.86 39.3 41.41L46.51 38.18C47.52 37.73 48.7 38.18 49.15 39.19C49.6 40.2 49.15 41.38 48.14 41.83L40.93 45.06C40.66 45.18 40.39 45.24 40.11 45.24L40.12 45.23Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.54 38.77C53.78 38.77 53.05 38.33 52.71 37.59C52.26 36.58 52.71 35.4 53.72 34.95L59.2 32.5C59.72 32.27 60.31 32.27 60.83 32.5L66.32 34.93C67.33 35.38 67.79 36.56 67.34 37.57C66.89 38.58 65.71 39.04 64.7 38.59L60.03 36.52L55.37 38.61C55.1 38.73 54.83 38.79 54.55 38.79L54.54 38.77Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.18 45.23C79.91 45.23 79.64 45.17 79.37 45.06L72.03 41.81C71.02 41.36 70.56 40.18 71.01 39.17C71.46 38.16 72.64 37.7 73.65 38.15L80.99 41.4C82 41.85 82.46 43.03 82.01 44.04C81.68 44.79 80.95 45.23 80.18 45.23Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.63 53.59C86.9 53.59 86.19 53.18 85.84 52.48C85.35 51.49 85.75 50.29 86.73 49.8L88.3 49.02L86.7 48.31C85.69 47.86 85.23 46.68 85.68 45.67C86.13 44.66 87.31 44.2 88.32 44.65L93.81 47.08C94.52 47.39 94.98 48.09 95 48.86C95.02 49.63 94.59 50.35 93.9 50.7L88.53 53.38C88.24 53.52 87.94 53.59 87.64 53.59H87.63Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.81 60.9C72.07 60.9 71.36 60.49 71.01 59.78C70.52 58.79 70.93 57.59 71.93 57.1L79.35 53.46C80.34 52.97 81.54 53.38 82.03 54.38C82.52 55.37 82.11 56.57 81.11 57.06L73.69 60.7C73.41 60.84 73.11 60.9 72.81 60.9Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.21 90.26C59.89 90.26 59.57 90.18 59.28 90.03L34.65 77.13C33.99 76.79 33.58 76.1 33.58 75.36V61.29C33.58 60.19 34.48 59.29 35.58 59.29C36.68 59.29 37.58 60.19 37.58 61.29V74.15L60.21 86L82.84 74.15V61.29C82.84 60.19 83.74 59.29 84.84 59.29C85.94 59.29 86.84 60.19 86.84 61.29V75.36C86.84 76.1 86.43 76.79 85.77 77.13L61.14 90.03C60.85 90.18 60.53 90.26 60.21 90.26Z",
    fill: "#1A1B43"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1657_2989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyTrainingcourses);
export default __webpack_public_path__ + "static/media/icon-empty-trainingcourses.a1fe6005af0cfc067f82c8cdda489a51.svg";
export { ForwardRef as ReactComponent };